(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tcg-card-item"] && !Shopify.designMode) return;
  try {
    // Card slider arrows
  (function() {
    document.querySelectorAll('[data-card-slider]').forEach(function(wrapper) {
      var slides = wrapper.querySelectorAll('[data-slide-index]');
      var dots = wrapper.querySelectorAll('[data-dot-index]');
      var total = slides.length;
      var current = 0;

      function goTo(idx) {
        if (idx < 0) idx = total - 1;
        if (idx >= total) idx = 0;
        slides.forEach(function(s) { s.classList.remove('is-active'); });
        dots.forEach(function(d) { d.classList.remove('is-active'); });
        slides[idx].classList.add('is-active');
        if (dots[idx]) dots[idx].classList.add('is-active');
        current = idx;
      }

      var prev = wrapper.querySelector('[data-slide-prev]');
      var next = wrapper.querySelector('[data-slide-next]');
      if (prev) prev.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); goTo(current - 1); });
      if (next) next.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); goTo(current + 1); });

      // Touch: horizontal swipe changes the image (the arrows are hidden on touch screens).
      if (total > 1) {
        var x0 = null, y0 = null;
        wrapper.addEventListener('touchstart', function(e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        wrapper.addEventListener('touchend', function(e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) goTo(current + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    });
  })();

  // Make card clickable via data attribute
  document.querySelectorAll('.tcg-card-item[data-product-url]').forEach(function(card) {
    card.addEventListener('click', function(e) {
      if (e.target.closest('.tcg-card__quick-add') || e.target.closest('.tcg-card__arrow') || e.target.closest('.vaultx-swatch-list') || e.target.closest('button')) return;
      window.location.href = card.dataset.productUrl;
    });
  });

  // Vault X Swatch Card Interactivity
  (function() {
    function updateCardState(card, swatchItem) {
      if (!card || !swatchItem) return;
      
      // Update active swatch
      var siblings = swatchItem.parentNode.querySelectorAll('.vaultx-swatch-item');
      siblings.forEach(function(s) { s.classList.remove('active'); });
      swatchItem.classList.add('active');
      
      // Update image
      var imageId = swatchItem.getAttribute('data-image-id');
      if (imageId) {
        var targetSlide = card.querySelector('.tcg-card__slide[data-image-id="' + imageId + '"]');
        if (targetSlide) {
          card.querySelectorAll('.tcg-card__slide').forEach(function(s) { s.classList.remove('is-active'); });
          targetSlide.classList.add('is-active');
          
          var slideIdx = targetSlide.getAttribute('data-slide-index');
          if (slideIdx !== null) {
            card.querySelectorAll('.tcg-card__dot').forEach(function(d) { d.classList.remove('is-active'); });
            var dot = card.querySelector('.tcg-card__dot[data-dot-index="' + slideIdx + '"]');
            if (dot) dot.classList.add('is-active');
          }
        }
      }
      
      // Update Add to Cart variant ID
      var variantId = swatchItem.getAttribute('data-id');
      var hiddenInput = card.querySelector('form.tcg-card__quick-form input[name="id"]');
      if (hiddenInput && variantId) {
        hiddenInput.value = variantId;
      }
      
      // Update card product url parameter so clicking card redirects to this variant
      var newUrl = swatchItem.getAttribute('data-url');
      if (newUrl) {
        card.setAttribute('data-product-url', newUrl);
      }
    }

    document.addEventListener('mouseover', function(e) {
      var swatchItem = e.target.closest('.vaultx-swatch-item');
      if (!swatchItem) return;
      var card = swatchItem.closest('.tcg-card-item');
      updateCardState(card, swatchItem);
    });

    document.addEventListener('click', function(e) {
      var swatchItem = e.target.closest('.vaultx-swatch-item');
      if (!swatchItem) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      var card = swatchItem.closest('.tcg-card-item');
      updateCardState(card, swatchItem);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
